export default class Base extends Error {
  constructor({type, title, message}) {
    super(message)
    // @Ed kan je dit dubbelchecken, of dit een oke manier is om dit dynamisch te maken?
    this.type = type
    this.title = title
    this.message = message
  }

  getType() {
    return this.type
  }
  getTitle() {
    return this.title
  }
  getMessage() {
    return this.message
  }
}
